import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppSettingsService } from '@app/services/api/app-settings.service';

@Injectable({
    providedIn: 'root'
})
export class AppSettingsStateService {
    private _forceAdjustedHoursEnabled = new BehaviorSubject<boolean>(false);
    private _initialized = false;

    constructor(private appSettingsService: AppSettingsService) {}

    get forceAdjustedHoursEnabled$(): Observable<boolean> {
        if (!this._initialized) {
            this.loadSetting();
        }
        return this._forceAdjustedHoursEnabled.asObservable();
    }

    get forceAdjustedHoursEnabled(): boolean {
        return this._forceAdjustedHoursEnabled.value;
    }

    private loadSetting(): void {
        this._initialized = true;
        this.appSettingsService.getForceAdjustedHours().subscribe({
            next: (response) => {
                this._forceAdjustedHoursEnabled.next(response.enabled);
            },
            error: (error) => {
                console.error('Error loading force adjusted hours setting:', error);
            }
        });
    }

    toggleSetting(): Observable<any> {
        return new Observable(observer => {
            this.appSettingsService.toggleForceAdjustedHours().subscribe({
                next: (response) => {
                    this._forceAdjustedHoursEnabled.next(response.enabled);
                    observer.next(response);
                    observer.complete();
                },
                error: (error) => {
                    observer.error(error);
                }
            });
        });
    }
}